const Premiere = [
  {
    id: 1,
    Movie: "Black Adam",
    Format: "4K",
    Language: "English, Audio(4), Subtitles(1)",
    Duration: "2h 5m",
    Genre: "Action, Fantasy, Sci-Fi",
    Date: "20 Oct, 2022",
    Cost: "699",
    Info: "A slave-turned-god, Teth-Adam (Dwayne Johnson) breaks free of his prison and fights to save his homeland from an ancient evil.",
    src: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:q-80/et00117411-zmudrhhzzz-portrait.jpg",
  },
  {
    id: 2,
    Movie: "Top Gun : Maverick",
    Language: "English, Audio(4), Subtitles(1)",
    Duration: "2h 11m",
    Genre: "Action, Drama",
    Date: "27 May, 2022",
    Cost: "119",
    Info: "Set 30 years after the events of `Top Gun` (1986), the sequel hinges on Captain Pete Mitchell`s (Tom Cruise) attempts to come to terms with his past, while training his friend`s son (Miles Teller) for a dangerous mission.",
    src: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:q-80/et00076943-smkpwvadsk-portrait.jpg",
  },
  {
    id: 3,
    Movie: "Tumi O Tumi",
    Language: "Bengali, Audio(1), Subtitles(1)",
    Duration: "2h 2m",
    Genre: "Drama",
    Date: "17 Jan, 2022",
    Cost: "150",
    Info: "This empowering and touching social drama brings to life the daily struggles of three women across different generations.",
    src: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:oi-discovery-catalog@@icons@@bms_premiere_v1.png,oit-false,ofo-bottom_left:q-80/et00119947-ednhelsdft-portrait.jpg",
  },
  {
    id: 4,
    Movie: "Detection of Di-Renji",
    Language: "Mandarin, Audio(4), Subtitles(1)",
    Duration: "1h 33m",
    Genre: "Action, Mystery, Thriller",
    Date: "12 Jan, 2020",
    Cost: "29",
    Info: "In Empress Wu's reign, several bizarre deaths happen in Chang'an. Di Renjie is ordered to investigate the case. After multiple investigations, Di finally finds out the true murderer.",
    src: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:oi-discovery-catalog@@icons@@bms_premiere_v1.png,oit-false,ofo-bottom_left:q-80/et00338333-xmuuathedf-portrait.jpg",
  },
  {
    id: 5,
    Movie: "Nightmare Neighborhoud Moms",
    Language: "English, Audio(1), Subtitles(1)",
    Genre: "Drama, Thriller",
    Date: "8 Apr, 2020",
    Duration: "2h 13m",
    Cost: "179",
    Info: "Two ambitious and competitive women take their rivalry a step further by planning each other`s murders.",
    src: "https://assets-in.bmscdn.com/iedb/movies/images/extra/vertical_logo/mobile/thumbnail/xxlarge/nightmare-neighborhood-moms-et00347059-1670850284.jpg",
  },
  {
    id: 6,
    Movie: "Ebhabei Golpo Hok",
    Language: "Bengali, Audio(1), Subtitles(1)",
    Genre: "Drama",
    Date: "15 Oct, 2020",
    Duration: "1hr 53 mins",
    Cost: "119",
    Info: "Avijit, a director by profession, well-known for his thriller movies, decides to make a romantic film. Will he be able to make a successful romantic film?",
    src: "https://assets-in.bmscdn.com/iedb/movies/images/extra/vertical_logo/mobile/thumbnail/xxlarge/ebhabei-golpo-hok-et00145596-1672997391.jpg",
  },
  {
    id: 7,
    Movie: "Ticket to Paradise",
    Language: "English, Audio(2), Subtitles(1)",
    Genre: "Comedy, Romantic",
    Date: "6 Oct, 2022",
    Duration: "1hr 44 mins",
    Cost: "149",
    Info: "Bitter exes Georgia (Julia Roberts) and David (George Clooney) team up to stop their daughter, Lily (Kaitlyn Denver), from committing the biggest mistake of her life: getting married.",
    src: "https://assets-in.bmscdn.com/iedb/movies/images/extra/vertical_logo/mobile/thumbnail/xxlarge/ticket-to-paradise-et00338333-1672044076.jpg",
  },
  {
    id: 8,
    Movie: "Secret Headquarters",
    Language: "English, Audio(2), Subtitles(1)",
    Genre: "Action, Adventure, Comedy",
    Date: "12 Aug, 2022",
    Duration: "1hr 44mins",
    Cost: "699",
    Info: "A young boy discovers the hideout of the world`s most famous superhero with his friends. However, when villains attack, Charlie is forced to defend his hero`s home.",
    src: "https://assets-in.bmscdn.com/iedb/movies/images/extra/vertical_logo/mobile/thumbnail/xxlarge/secret-headquarters-et00347789-1672912083.jpg",
  }
];

export default Premiere;
